import {Type} from 'main.core';

export class Form
{
	constructor(options = {name: 'Form'})
	{
		this.name = options.name;
		this.initEventListener()
	}

	initEventListener()
	{
		const instance = this
		$(document).on('submit', '.js-ajax-form', function(e){
			e.preventDefault()

			if (instance.checkRequred($(this)) === false) {
				return false;
			}

			let data = $(this).serialize()
			let url = $(this).attr('action')
			let method = $(this).attr('method')

			$.ajax({
				url: url,
				method: method,
				data: data,
				success: function(e) {
					$.fancybox.close();
					$.fancybox.open('<div class="popup"><h3>Ваша заявка успешно отправлена, дождитесь звонка менеджера</h3></div>');
				}
			})
		})
	}

	checkRequred(form)
	{
		if (form.find('[required="required"]').filter(
			function() {
				if (this.type === "checkbox") {
					return this.value !== "on";
				} else {
					return this.value === ''
				}
			}
		).length > 0) {
			return false;
		}
	}

	setName(name)
	{
		if (Type.isString(name))
		{
			this.name = name;
		}
	}

	getName()
	{
		return this.name;
	}

}